/**
 * Where the sun is, which is what a screen on a boat should be reading rather than a light
 * sensor: a hand over the phone is not nightfall, and a chart table lamp is not dawn.
 *
 * The usual low-precision solar position — mean anomaly, equation of the centre, an
 * obliquity of 23.4397° — good to about a hundredth of a degree, which is a great deal
 * finer than the question "is it dark yet" requires.
 */
const RAD = Math.PI / 180;
const J2000 = Date.UTC(2000, 0, 1, 12); // the epoch, as milliseconds
/** Days since J2000, fractional */
function since(time) {
    return (time - J2000) / 86_400_000;
}
/**
 * The sun's height above the horizon in degrees, negative below it. Longitude is positive
 * east, as everywhere else in this app.
 */
export function sunAltitude(time, latitude, longitude) {
    const n = since(time);
    const meanAnomaly = (357.5291 + 0.98560028 * n) * RAD;
    const centre = (1.9148 * Math.sin(meanAnomaly) + 0.02 * Math.sin(2 * meanAnomaly) +
        0.0003 * Math.sin(3 * meanAnomaly)) * RAD;
    // the ecliptic longitude of the sun, from the perihelion of the earth's orbit
    const eclipticLongitude = meanAnomaly + centre + (102.9372 + 180) * RAD;
    const obliquity = 23.4397 * RAD;
    const declination = Math.asin(Math.sin(obliquity) * Math.sin(eclipticLongitude));
    const rightAscension = Math.atan2(Math.cos(obliquity) * Math.sin(eclipticLongitude), Math.cos(eclipticLongitude));
    const siderealTime = (280.16 + 360.9856235 * n) * RAD + longitude * RAD;
    const hourAngle = siderealTime - rightAscension;
    const phi = latitude * RAD;
    const altitude = Math.asin(Math.sin(phi) * Math.sin(declination) +
        Math.cos(phi) * Math.cos(declination) * Math.cos(hourAngle));
    return altitude / RAD;
}
/**
 * Daylight, twilight, or dark, by the sun's own definition: the civil twilight that ends
 * when the horizon goes and the first stars come out is exactly when a chart screen should
 * stop being white and start being red.
 */
export function dayPart(time, latitude, longitude) {
    const altitude = sunAltitude(time, latitude, longitude);
    if (altitude > 0)
        return 'day';
    return altitude > -6 ? 'dusk' : 'night';
}
//# sourceMappingURL=sun.js.map